import { useState } from 'react';
import React from 'react';
import Tippy from '@tippyjs/react';
import './ProductListMenu.css';
import { useSelector } from 'react-redux';
import { getAuth } from '../../../../selectors/auth';
import { useTranslation } from 'react-i18next';
import { AlbumState } from '../../../../data/models/albumState';
import {
  Delete,
  Edit,
  Duplicate,
  DuplicateForDigital,
} from '../../../../constants/Operations';
import useAuthUtilities from '../../../../AuthMiddleware/AuthUtilities';
import { isAlbumReadOnlyStates } from '@/components/common/ProductUtilities';

const ProductListPopupCellRenderer = (props: any) => {
  const [visible, setVisible] = useState(false);
  const show = () => setVisible(true);
  const hide = () => setVisible(false);
  const { hasWriteAccess } = useSelector(getAuth);
  const { t } = useTranslation();
  const { canUserEditProduct } = useAuthUtilities();

  const dropDownContent = (
    <div className="menu-container">
      <div onClick={() => onClickHandler(Edit)} className="menu-item">
        {canUserEditProduct(props.data.albumState) &&
        !isAlbumReadOnlyStates(props.data.albumState) ? (
          <>
            <span className="icon fas fa-solid fa-pencil blue-color"></span>
            <span className="item-text">
              {t('product.productMenu.editSubmission')}
            </span>
          </>
        ) : (
          <>
            <span className="icon fas fa-solid fa-info-circle blue-color"></span>
            <span className="item-text">
              {t('product.productMenu.viewDetails')}
            </span>
          </>
        )}
      </div>
      {hasWriteAccess ? (
        <div onClick={() => onClickHandler(Duplicate)} className="menu-item">
          <span className="icon fas fa-solid fa-clone blue-color"></span>
          <span className="item-text">
            {t('product.productList.duplicateProduct')}
          </span>
        </div>
      ) : null}
      {hasWriteAccess ? (
        <div
          onClick={() => onClickHandler(DuplicateForDigital)}
          className="menu-item"
        >
          <span className="icon fas fa-solid fa-clone blue-color"></span>
          <span className="item-text">
            {t('productActions.dropdown.menu.duplicateForDigital')}
          </span>
        </div>
      ) : null}
      {hasWriteAccess && props.data.albumState === AlbumState.Draft ? (
        <div onClick={() => onClickHandler(Delete)} className="menu-item">
          <span className="icon fas fa-solid fa-times blue-color"></span>
          <span className="item-text left-align">
            {t('product.productMenu.deleteSubmission')}
          </span>
        </div>
      ) : null}
    </div>
  );

  const onClickHandler = (option: any) => {
    hide();
    props.context.processAlbum(props.data, option);
  };

  return (
    <Tippy
      content={dropDownContent}
      visible={visible}
      onClickOutside={hide}
      allowHTML={true}
      arrow={false}
      appendTo={document.body}
      interactive={true}
      placement="left"
    >
      <span
        className="icon fas fa-ellipsis-v action-menu-icon button-span"
        onClick={visible ? hide : show}
      ></span>
    </Tippy>
  );
};
export default ProductListPopupCellRenderer;
